import React from 'react';

interface ImageWithSkeletonProps {
    src: string;
    alt: string;
    loading?: 'eager' | 'lazy';
    style?: React.CSSProperties;
    className?: string;
}

/**
 * Simple image component without loader
 * Loader is handled globally at the app level
 */
const ImageWithSkeleton: React.FC<ImageWithSkeletonProps> = ({
    src,
    alt,
    loading = 'lazy',
    style,
    className
}) => {
    return (
        <img
            src={src}
            alt={alt}
            loading={loading}
            className={className}
            style={style}
        />
    );
};

export default ImageWithSkeleton;
